
import {urlConfig} from '@/api/urlConfig';
import Msg from 'vux/src/components/msg/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'

export default {
data(){
return {
buttons: [{
type: 'primary',
text: '继续兑换',
onClick: this.gopay.bind(this)
}, {
type: 'default',
text: '查看我的积分',
onClick: this.look.bind(this)
}]
}
},
components: {
Msg,XButton,XHeader
},
computed:{
},
methods:{
gopay(){
this.$router.push({ path: 'integralMall?openid='+this.$route.query.openid,sign:this.$route.query.sign+'&hosCode='+this.$route.query.hosCode});
},
look(){
this.$router.push({ path: 'integralMall?openid='+this.$route.query.openid,sign:this.$route.query.sign+'&hosCode='+this.$route.query.hosCode});
}
},
mounted(){
}
}



// WEBPACK FOOTER //
// ./src/project/integralMallProject/integralMallOrderResult.vue